import { render, staticRenderFns } from "./acerca-de.vue?vue&type=template&id=24670785&"
import script from "./acerca-de.vue?vue&type=script&lang=js&"
export * from "./acerca-de.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports